/* cart-drawer-tiny.js — refresh the drawer and emit subtotal; never loop; never open on /cart */
(() => {
  if (window.__CART_DRAWER_FIX__) return;
  window.__CART_DRAWER_FIX__ = true;

  const OVERLAY_SEL = '[data-cart-drawer]';
  const INNER_SEL   = '[data-cart-drawer-inner]';

  const overlay = document.querySelector(OVERLAY_SEL);
  if (!overlay) return;

  const delay = (ms)=>new Promise(r=>setTimeout(r,ms));

  const isCartPage = () =>
    document.body.classList.contains('template-cart') ||
    location.pathname.replace(/\/+$/,'') === '/cart';

  function openDrawer() {
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-open');
  }
  function closeDrawer() {
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-open');
  }

  // ---- Replace inner drawer HTML from section ----
  async function renderDrawer() {
    const html = await fetch('/cart?section_id=cart-drawer', { headers: { 'Cache-Control': 'no-cache' } }).then(r => r.text());
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const fresh = tmp.querySelector('#shopify-section-cart-drawer ' + INNER_SEL) || tmp.querySelector(INNER_SEL);
    const target = overlay.querySelector(INNER_SEL);
    if (fresh && target) target.replaceWith(fresh);
  }

  // ---- Read subtotal cents from shipping bar in the drawer ----
  function readSubtotalCentsFromDrawer() {
    const bar = overlay.querySelector('#shipping-progress');
    const cents = Number(bar?.dataset?.subtotalCents);
    return Number.isFinite(cents) ? cents : null;
  }

  // ---- Tell other parts of the theme to update shipping bars ----
  function emitCartRefresh(subtotalCents) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { subtotalCents } }));
  }

  // ---- Main: refresh drawer, emit subtotal, optionally open ----
  async function refreshAndMaybeOpen() {
    await renderDrawer();
    emitCartRefresh(readSubtotalCentsFromDrawer());

    // Never open the drawer on the dedicated /cart page
    if (isCartPage()) return;

    // Small delay for smoother transition
    await delay(120);
    openDrawer();
  }

  // Close handlers
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-close], [data-cart-close] *')) closeDrawer();
    if (e.target === overlay) closeDrawer();
  });

  // Patch fetch: after /cart/*.js mutations, refresh & maybe open
  const _fetch = window.fetch;
  window.fetch = async function patchedFetch(input, init) {
    const p = _fetch(input, init);
    try {
      const url = (typeof input === 'string' ? input : input.url) || '';
      const mut = /\/cart\/(add|change|update)\.js(\?|$)/.test(url);
      const res = await p;
      if (mut && res.ok) refreshAndMaybeOpen();
      return res;
    } catch (e) {
      return p;
    }
  };

  // Handle non-AJAX add-to-cart forms that navigate:
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (/\/cart\/add(\.js)?/.test(action) && !/\.js$/.test(action)) {
      sessionStorage.setItem('openDrawerAfterNav', '1');
    }
  }, true);

  // After navigation, only open if not on /cart
  if (sessionStorage.getItem('openDrawerAfterNav') === '1') {
    sessionStorage.removeItem('openDrawerAfterNav');
    refreshAndMaybeOpen();
  }
})();